import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('details-block', {
    staticClass: "mt-15",
    attrs: {
      "title": _vm.t('操作记录'),
      "isFilledDefault": true
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "data-sign": "product_freeze_log_list",
      "data-source": _vm.data.freeze_log_list || [],
      "bordered": ""
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };